import React, { createContext, useState } from "react";
import NavBar from "./components/NavBar";
import Portal from "./pages/Portal";

const App = () => {
  return (
    <AppContextProvider>
      <AppContextConsumer>
        {(appContext) => {
          return (
            <>
              <NavBar />
              <Portal appContext={appContext} />
            </>
          );
        }}
      </AppContextConsumer>
    </AppContextProvider>
  );
};

export default App;

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [state, setState] = useState({});

  const setAccessToken = (accessToken) => {
    console.log({ accessToken });
    setState({ accessToken: accessToken });
  };

  return (
    <AppContext.Provider value={{ state, setAccessToken: setAccessToken }}>
      {children}
    </AppContext.Provider>
  );
};

export const AppContextConsumer = AppContext.Consumer;
